import { FascicoloDTO } from "./fascicoloDTO";
import { MetadatiProtocolloDTO } from "./metadati-protocolloDTO";
import { TempiConservazioneDTO } from "./tempi-conservazioneDTO";
import { TipologiaDocumentoDTO } from "./tipologia-documentoDTO";
import { CampoSpecificoFascicoloDTO } from "./campo-specifico-fascicoloDTO";
import { TipoSupportoDocumentoEnum } from "../enum/tipo-supporto-documento-enum";
import { SettoreDTO } from "./settoreDTO";
import { ClassificaDTO } from "./classificaDTO";
import { StatoUnitaDocumentariaEnum } from "../enum/stato-unita-documentaria-enum";

export class FiltroRicercaUnitaDocumentariaDTO {
  oggetto: string;

  fascicoloAppartenenza: FascicoloDTO;

  voceClassifica: ClassificaDTO;

  metadatiProtocollo: MetadatiProtocolloDTO;

  dataProtocolloDal: string;

  dataProtocolloAl: string;

  dataAnniInserimentoFascicoloDal: string;

  dataAnniInserimentoFascicoloAl: string;

  dataAnniInserimentoSistemaDal: string;

  dataAnniInserimentoSistemaAl: string;

  dataAnniModificaDal: string;

  dataAnniModificaAl: string;

  dataAnniChiusuraDal: string;

  dataAnniChiusuraAl: string;

  dataAnniArchiviazioneDal: string;

  dataAnniArchiviazioneAl: string;

  inseritoDa: string;

  inseritoDaCf: string;

  stato: StatoUnitaDocumentariaEnum;

  codiceClassificazione: string;

  codiceStrutturaCmu: string;

  strutturaResponsabile: SettoreDTO;

  tempiConservazione: TempiConservazioneDTO;

  numeroRepertorio: number;

  dataAnniRepertoriazioneDal: string;

  dataAnniRepertoriazioneAl: string;

  tipo: TipoSupportoDocumentoEnum;

  tipologiaDocumento: TipologiaDocumentoDTO;

  campiSpecifici: CampoSpecificoFascicoloDTO[];

  nomeFile: string;

  statoDaEscludere: string;

  idRepository: string;

  hash: string;

  limitazioniVisibilitaUtente: boolean;

  ricercaSemplice: string;

  descrizioneFile: string;

  firmatario: string;

  autore: string;

  dataManuale: string;

  collocazioneFisica: string;

  originale: string;
}
